<template>
    <p>
        <img :src="src" alt="">
    </p>
</template>
<script>
export default {
    name: 'c_sign',
    props: {
        sign: {
            type: Number
        }
    },
    computed: {
        text() {
            return Number(this.sign) === 1 ? '自营' : '优选'
        },
        src() {
            return Number(this.sign) === 1 ? require('@/assets/images/1.png') : require('@/assets/images/2.png')
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixin.scss";

p {
    font-size: 0;
    margin-left: 10px;

    &.self {
        color: #439dfa;
        background-color: #5796db;
    }

    &.adv {
        color: #e0620d;
        background-color: #dd650d;
    }

    img {
        height: px2vw(22);
    }
}

@media screen and (max-width: 750px) {
    p {
        img {
            height: px2vw4m(28);
        }
    }
}
</style>